import { sortSiteNamesNumerically } from '../randomize/sortUtils'

interface SiteFeature {
  properties: {
    isRandomSite?: boolean
    name?: string
    id?: string | number
    newManualSite?: boolean
  }
}

/**
 * Resuelve el sitio manual que ocupa `displayIndex` en el PANEL. El panel muestra
 * los manuales ordenados (sortSiteNamesNumerically), así que indexar la lista cruda
 * (orden de inserción) borraría el sitio equivocado cuando ambos órdenes difieren.
 */
export function getManualSiteByDisplayIndex<T extends SiteFeature>(
  allSites: T[],
  displayIndex: number,
): T | undefined {
  const manualSites = sortSiteNamesNumerically(
    (allSites || []).filter(site => !site.properties.isRandomSite),
  )
  return manualSites[displayIndex]
}
